import { render, staticRenderFns } from "./gwgl.vue?vue&type=template&id=73965c5e&scoped=true&"
import script from "./gwgl.vue?vue&type=script&lang=js&"
export * from "./gwgl.vue?vue&type=script&lang=js&"
import style0 from "./gwgl.vue?vue&type=style&index=0&id=73965c5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73965c5e",
  null
  
)

export default component.exports